import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'billing_prices'

export default {
  key: DATASET_KEY,
  label: 'Facturación - Precios',
  timeColumn: 'billing_prices.created_at',
  permission: { action: 'read', subject: 'BillingPrice' },

  tables: {
    billing_prices: ["id", "region", "security_company", "description", "profile", "hours", "days", "cost_per_hour", "cost_per_shift", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'billing_prices.security_company',
  },

  csvConfig: {
    withTables: 'billing_prices',
    columns: '',
    count: { limit: -1 },
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
    //timeseries: { trendline: true },
  },

  fields: [
    { key: 'billing_prices.security_company', label: 'Empresa de seguridad' },
    { key: 'billing_prices.description', label: 'Descripción' },
    { key: 'billing_prices.profile', label: 'Perfil' },
    { key: 'billing_prices.region', label: 'Región' },
    { key: 'billing_prices.hours', label: 'Horas' },
    { key: 'billing_prices.days', label: 'Días' },
    { key: 'billing_prices.cost_per_hour', label: 'Costo por hora' },
    { key: 'billing_prices.cost_per_shift', label: 'Costo por turno' },
    { key: 'billing_prices.created_at', label: 'Creado el', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'billing_prices.description', 'Descripción', 'name'),
    embedFilter(DATASET_KEY, 'billing_prices.security_company', 'Empresa de seguridad', 'group'),
    embedFilter(DATASET_KEY, 'billing_prices.profile', 'Perfil', 'reference'),
    embedFilter(DATASET_KEY, 'billing_prices.region', 'Región', 'type'),
    embedFilter(DATASET_KEY, 'billing_prices.hours', 'Horas', 'hours'),
    embedFilter(DATASET_KEY, 'billing_prices.days', 'Días', 'days'),
    embedFilter(DATASET_KEY, 'billing_prices.cost_per_hour', 'Costo por hora', 'cost_per_hour'),
    embedFilter(DATASET_KEY, 'billing_prices.cost_per_shift', 'Costo por turno', 'cost_per_shift'),
  ],

  dateGrouping: {
    column: 'billing_prices.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
